import * as effects from 'redux-saga/effects';
import { IDeclarationStatusActionTypes } from './Types';
import {
  getDeclarationStatus,
  getDeclarationStatusFailure,
  getDeclarationStatusSuccess,
} from './Actions';
import { Backend } from '../../Backend/Backend';

function* handleGetDeclarationStatus(
  action: ReturnType<typeof getDeclarationStatus>
) {
  const backend = Backend.getInstance();
  try {
    const result = yield effects.apply(backend, backend.getDeclarationStatus, [
      action.payload.reference_ad_id,
      action.payload.bucket_id,
    ]);
    if (result) {
      // todo implement verification result is Declaration Status
      yield effects.put(getDeclarationStatusSuccess(result));
    } else {
      throw new Error('response is not a result');
    }
  } catch (err) {
    if (err instanceof Error) {
      yield effects.put(getDeclarationStatusFailure(err.message));
    } else if (typeof err === 'string') {
      yield effects.put(getDeclarationStatusFailure(err));
    } else {
      yield effects.put(getDeclarationStatusFailure('Unknown error occurred'));
      console.log(err);
    }
  }
}

function* watchDeclarationStatus() {
  yield effects.takeEvery(
    IDeclarationStatusActionTypes.GET_DECLARATION_STATUS,
    handleGetDeclarationStatus
  );
}

export function* DeclarationStatusSaga() {
  yield effects.all([effects.fork(watchDeclarationStatus)]);
}
